<template>
  <div class="apply-loan-container">
    <section class="apply-loan" ref="applyLoan">
      <keep-alive>
        <router-view class="apply-loan__router-view" ref="applyLoanRouterView"></router-view>
      </keep-alive>
    </section>
  </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    mounted () {
//      this.$refs.applyLoan.style.height = `${window.innerHeight - 50 - 30}px`
    }
  }
</script>
<style lang="scss">    //申请页面背景色
  .apply-loan-container {
    /*overflow: auto;*/
    /*height:100%;*/
    overflow: hidden;
    //background: #fdf5e9;
 background: #dbdbdb;

  }

  .apply-loan {
    margin: 50px auto;
    /*width: $containerWidth;*/
  }

  .apply-loan__router-view {
    @include resetBFC;
    padding-top: 20px;
    padding-bottom: 20px;
    min-height: 550px;
  }
</style>



// WEBPACK FOOTER //
// ApplyLoan.vue?1f2c32fc